import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

const SET_APP_VERSION = 'status/SET_APP_VERSION';
const SET_LANGUAGE = 'status/SET_LANGUAGE';
const SET_DEVICE_INFO = 'status/SET_DEVICE_INFO';
const SET_IS_POPUP_ACTIVE = 'status/SET_IS_POPUP_ACTIVE';
const CHECK_FIRST_OPEN = 'status/CHECK_FIRST_OPEN';
const SET_PAGE_TITLE = 'status/SET_PAGE_TITLE';
const SET_HEADER_TYPE = 'status/SET_HEADER_TYPE';
const SET_NAV_TAB = 'status/SET_NAV_TAB';
const SET_SHAMPOO_RESULT_TAB = 'status/SET_SHAMPOO_RESULT_TAB';
const SET_INITIAL_CARD_IDX = 'status/SET_INITIAL_CARD_IDX';
const SET_SCROLL_TO_ID = 'status/SET_SCROLL_TO_ID';
export const SET_SHOW_LOADING = 'status/SET_SHOW_LOADING';
const SET_POPUP_BUTTON_CLICKED = 'status/SET_POPUP_BUTTON_CLICKED';
const SET_PAGE_TYPE = 'status/SET_PAGE_TYPE';

/** FCM TOKEN 이란? 앱의 푸시 알림 기능을 위한 것. */
const SET_FCM_TOKEN = 'status/SET_FCM_TOKEN';
/** 사용자의 휴대폰 환경설정 앱 푸시 알림 ON/OFF check */
const SET_NOTIFICATION = 'status/SET_NOTIFICATION';

export const setAppVersion = createAction(
  SET_APP_VERSION,
  (version) => version,
);
export const setLanguage = createAction(SET_LANGUAGE, (language) => language);
export const setDeviceInfo = createAction(
  SET_DEVICE_INFO,
  (deviceInfo) => deviceInfo,
);
export const setIsPopupActive = createAction(
  SET_IS_POPUP_ACTIVE,
  (isPopupActive) => isPopupActive,
);
export const setPopupButtonClicked = createAction(
  SET_POPUP_BUTTON_CLICKED,
  (popupButtonClicked) => popupButtonClicked,
);
export const checkFirstOpen = createAction(
  CHECK_FIRST_OPEN,
  (firstOpen) => firstOpen,
);
export const setPageTitle = createAction(
  SET_PAGE_TITLE,
  (pageTitle) => pageTitle,
);

export const setPageType = createAction(SET_PAGE_TYPE, (pageType) => pageType);

export const setHeaderType = createAction(
  SET_HEADER_TYPE,
  (headerType) => headerType,
);
export const setNavTab = createAction(SET_NAV_TAB, (navTab) => navTab);
export const setShampooResultTab = createAction(
  SET_SHAMPOO_RESULT_TAB,
  (shampooResultTab) => shampooResultTab,
);
export const setInitialCardIdx = createAction(
  SET_INITIAL_CARD_IDX,
  (initialCardIdx) => initialCardIdx,
);
export const setScrollToId = createAction(
  SET_SCROLL_TO_ID,
  (scrollToId) => scrollToId,
);
export const setShowLoading = createAction(
  SET_SHOW_LOADING,
  (showLoading) => showLoading,
);

export const setFcmToken = createAction(SET_FCM_TOKEN, (fcmToken) => fcmToken);
export const setNotification = createAction(
  SET_NOTIFICATION,
  (isAllowNotification) => isAllowNotification,
);

const initialState = {
  appVersion: '-',
  language: 'en',
  deviceInfo: {
    connectStatus: 'needBluetoothConnect', // complete, needWifiConnect, needBluetoothConnect
    device: {
      name: 'Withbecon-12345', // string
      wifiName: 'wifiname', // string
      battery: 0, // int
      os: '1.0.0', // string
      needUpdate: false,
      changeFlag: false, // device name 변경 가능 여부
    },
  },
  isPopupActive: false,
  popupButtonClicked: false,
  firstOpen: true,
  pageTitle: '',
  pageType: 'main',
  headerType: 'main',
  navTab: 0,
  shampooResultTab: 0,
  initialCardIdx: 0,
  scrollToId: null,
  inIframe: window.self !== window.top,
  showLoading: false,
  sessionId:
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15),
  fcmToken: '',
  isAllowNotification: false,
};

const status = handleActions(
  {
    // 앱 버전 가져오기
    [SET_APP_VERSION]: (state, { payload: version }) =>
      produce(state, (draft) => {
        draft.appVersion = version; // version 정보를 바꾼다
      }),
    // 시스템 언어 설정
    [SET_LANGUAGE]: (state, { payload: language }) => ({
      ...state,
      language: language,
    }),
    // 두피 스캐너 디바이스 연결 정보
    [SET_DEVICE_INFO]: (state, { payload: deviceInfo }) => ({
      ...state,
      deviceInfo: deviceInfo,
    }),
    // 팝업 or 모달을 활성화 혹은 비활성화
    [SET_IS_POPUP_ACTIVE]: (state, { payload: isPopupActive }) => ({
      ...state,
      isPopupActive: isPopupActive,
    }),
    // 팝업 or 모달을 활성화 혹은 비활성화
    [SET_POPUP_BUTTON_CLICKED]: (state, { payload: popupButtonClicked }) => ({
      ...state,
      popupButtonClicked: popupButtonClicked,
    }),
    // 앱 초기 오픈 상태를 저장
    [CHECK_FIRST_OPEN]: (state, { payload: firstOpen }) => ({
      ...state,
      firstOpen: firstOpen,
    }),
    [SET_PAGE_TITLE]: (state, { payload: pageTitle }) => ({
      ...state,
      pageTitle: pageTitle,
    }),
    //페이지가 어느 타입인지 main | zeroDepth | singleDepthSimple | singleDepth | multiDepth
    [SET_PAGE_TYPE]: (state, { payload: pageType }) => {
      return {
        ...state,
        pageType: pageType,
      };
    },
    [SET_HEADER_TYPE]: (state, { payload: headerType }) => ({
      ...state,
      headerType: headerType,
    }),
    [SET_NAV_TAB]: (state, { payload: navTab }) => ({
      ...state,
      navTab: navTab,
    }),
    [SET_SHAMPOO_RESULT_TAB]: (state, { payload: shampooResultTab }) => ({
      ...state,
      shampooResultTab: shampooResultTab,
    }),
    [SET_INITIAL_CARD_IDX]: (state, { payload: initialCardIdx }) => ({
      ...state,
      initialCardIdx: initialCardIdx,
    }),
    // 스크롤해야하는 element id를 제공
    [SET_SCROLL_TO_ID]: (state, { payload: scrollToId }) => ({
      ...state,
      scrollToId: scrollToId,
    }),
    [SET_SHOW_LOADING]: (state, { payload: showLoading }) => ({
      ...state,
      showLoading: showLoading,
    }),
    [SET_FCM_TOKEN]: (state, { payload: fcmToken }) => ({
      ...state,
      fcmToken: fcmToken,
    }),
    [SET_NOTIFICATION]: (state, { payload: isAllowNotification }) => ({
      ...state,
      isAllowNotification: isAllowNotification,
    }),
  },
  initialState,
);

export const getMainCurrentTab = (state) => state.status.navTab;

export default status;
